import { ref } from '@nuxtjs/composition-api';
import useVehicleSelectionSparesbox from '@shared/composables/useVehicleSelectionSparesbox';
import getFitmentSearchParams from '@shared/helpers/search/getFitmentSearchParams';
import { useFitmentSearch } from '@unified-commerce/gpc-vue-storefront-search';

const showFittingParts = ref(true);
const vehicleAskus = ref<{ askus?: string[]; kTypeNr?: string } | null>(null);

const toggleShowFittingParts = () => {
  showFittingParts.value = !showFittingParts.value;
};

const useFitmentData = () => {
  const {
    search: searchProductsFitment,
    result: productsFitmentResult,
    loading,
  } = useFitmentSearch('products-fitment');

  const { userSelectedVehicle } = useVehicleSelectionSparesbox();

  const getProductsFitmentData = async (searchResultsSkus: string[]) => {
    if (userSelectedVehicle.value && searchResultsSkus?.length > 0) {
      await searchProductsFitment(
        getFitmentSearchParams(searchResultsSkus, userSelectedVehicle.value.id),
      );
    }
  };

  return {
    loading,
    getProductsFitmentData,
    toggleShowFittingParts,
    productsFitmentResult,
    vehicleAskus,
    showFittingParts,
  };
};

export default useFitmentData;
